import { yup } from '@framework/validation';
import { IconType } from '../../advanced/buttons/icons/Icons';
import {
  ButtonAlign,
  ButtonType,
} from '../../advanced/buttons/types/ButtonEnums';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';

/**
 * Schema di base per il layout comune
 */
export const CommonBaseLayoutSchema = BaseLayoutSchema.shape({
  buttonType: yup
    .string()
    .oneOfEnum(ButtonType)
    .default(ButtonType.Primary)
    .optional()
    .label('Tipo di pulsante'),
  iconType: yup
    .string()
    .oneOfEnum(IconType)
    .default(IconType.Nessuna)
    .optional()
    .label('Icona di pulsante'),
  buttonAlign: yup
    .string()
    .oneOfEnum(ButtonAlign)
    .default(ButtonAlign.End)
    .optional()
    .label('Allineamento pulsante'),
})
  .optional()
  .noUnknown();
